<template>
  <div class="contact-page-container">
    <button @click="goBack" class="back-button">返回</button>
    <h1>联系我们</h1>
    <div class="contact-content">
      <p class="intro-text">
        演化空间，是AI信息高速公路旁的加油站，我们建立了AI进化社区，致力于打造最有前瞻性的AI社群。进高质量学习群。
      </p>
      <div class="qr-section">
        <div class="qr-item">
          <img src="@/assets/wechat-qrcode.png" alt="联系我们二维码" class="wechat-qrcode" />
          <div class="qr-description">
            <p>联系我们</p>
            <p>扫码加我们的微信，了解更多关于演化空间AI的信息。</p>
          </div>
        </div>
        <div class="qr-item">
          <img src="@/assets/wechatQ.png" alt="微信交流群二维码" class="wechat-qrcode" />
          <div class="qr-description">
            <p>加入微信交流群</p>
            <p>扫码加入我们的交流群，与其他AI爱好者互动。</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ContactPage',
  methods: {
    goBack() {
      this.$router.push({ name: 'HomePage' });
    },
  },
};
</script>

<style scoped>
.contact-page-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
  background-color: #f9f9f9;
  min-height: 100vh;
}

.back-button {
  align-self: flex-start;
  margin-bottom: 20px;
  background-color: #339;
  color: white;
  border: none;
  padding: 8px 12px;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.back-button:hover {
  background-color: #267;
}

.contact-content {
  text-align: center;
  margin-top: 20px;
}

.intro-text {
  margin-bottom: 30px;
  font-size: 16px;
  line-height: 1.5;
  color: #333;
}

.qr-section {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 20px;
  margin-top: 20px;
}

.qr-item {
  text-align: center;
  max-width: 200px;
}

.wechat-qrcode {
  width: 150px;
  height: 150px;
  margin-bottom: 10px;
}

.qr-description p {
  margin: 5px 0;
}

@media (max-width: 768px) {
  .qr-section {
    gap: 15px;
  }

  .intro-text {
    font-size: 14px;
  }

  .back-button {
    padding: 6px 10px;
    font-size: 14px;
  }

  .wechat-qrcode {
    width: 120px;
    height: 120px;
  }
}
</style>
